cb.define(['common/common_VM.Extend.js'], function () {

    var PM_pmc_ordermutexstrategy_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            const displayStrategy = (editModel) => {
                let editRowModels = viewmodel.get('odCtMutexStrategy').getCache('editRowModels');
                editModel.get("odCtMutexPromotion").on("beforeBrowse", function (data) {
                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    let promotionIds = [];
                    for (let i = 0; i < editRowModels.length; i++) {
                        let promotionList = editRowModels[i].get("odCtMutexPromotion").getRows();
                        if (promotionList) {
                            for (let j = 0; j < promotionList.length; j++) {
                                if (promotionList[j].iPromotionId) {
                                    promotionIds.push(promotionList[j].iPromotionId);
                                }
                            }
                        }
                    }
                    if (promotionIds && promotionIds.length > 0) {
                        condition.simpleVOs.push({
                            field: "id",
                            op: 'nin',
                            value1: promotionIds
                        });
                    }
                    data.context.setFilter(condition);
                })
            }

            const displayiSortNum = (editRowModels) => {
                if (editRowModels) {
                    for (let i = 0; i < editRowModels.length; i++) {
                        let odCtMutexPromotion = editRowModels[i].get("odCtMutexPromotion");
                        odCtMutexPromotion.setState('showColumnSetting', false);
                        displayStrategy(editRowModels[i]);
                        odCtMutexPromotion.on('beforeCellValueChange', function (data) {
                            let validatSuc = true;
                            if (data.cellName == 'iSortNum') {
                                if (data.value) {
                                    if (data.value > 0) {
                                        if (odCtMutexPromotion) {
                                            let rows = odCtMutexPromotion.getRows();
                                            rows.forEach(function (item, index) {
                                                if (index != data.rowIndex) {
                                                    if (data.value == item.iSortNum) {
                                                        cb.utils.alert('互斥活动优先级不能设置为相同', 'warning');
                                                        // data.value = '';
                                                        validatSuc = false;
                                                        //break;
                                                    }
                                                }
                                            })
                                        }
                                        return validatSuc
                                    } else {
                                        cb.utils.alert('优先级必须为正整数', 'warning');
                                        return false;
                                    }
                                }
                            }
                        })
                    }
                }
            }


            viewmodel.on('afterLoadData', function (data) {
                var mode = viewmodel.getParams().mode;
                if (mode === 'add') {
                    if (data.id != null && data.odCtMutexStrategy && data.odCtMutexStrategy.length > 0) {

                    } else {
                        viewmodel.get('odCtMutexStrategy').appendRow({});
                    }
                }
                displayiSortNum(viewmodel.get('odCtMutexStrategy').getCache('editRowModels'));
            });


            viewmodel.get("odCtMutexStrategy").on('afterInsertRow', function (args) {
                let editRowModels = viewmodel.get('odCtMutexStrategy').getCache('editRowModels');
                displayStrategy(editRowModels[args.index]);
                displayiSortNum(editRowModels)
            });

            viewmodel.on('beforeDeleteRow', function (args) {
                let odctStrategyCount = this.get('odCtMutexStrategy').getRowsCount();
                let isOnlyOneGroup = odctStrategyCount && odctStrategyCount == 1 && args.params.params.cItemName == 'btnDeleteRow1';
                if (isOnlyOneGroup) {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }

            });
            viewmodel.get('btnAddRow').setVisible(true);
            viewmodel.get('btnAddRow1').setVisible(true);
            viewmodel.get('btnDeleteRow1').setVisible(true);


            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                for (let i = 0; i < viewmodel.get('odCtMutexStrategy').getRows().length; i++) {
                    let strategy = viewmodel.get('odCtMutexStrategy').getRows()[i];
                    if (!strategy.cName) {
                        if (viewmodel.get('odCtMutexStrategy').getRows().length == 1) {
                            obj.odCtMutexStrategy[i].cName = '默认互斥策略';
                        } else {
                            cb.utils.alert('请输入第' + (i + 1) + '组的策略名称', 'warning');
                            return false;
                        }
                    }
                    let count = 0;
                    if ((!strategy.odCtMutexPromotion || strategy.odCtMutexPromotion.length == 0) && viewmodel.get('odCtMutexStrategy').getRows().length != 1) {
                        cb.utils.alert('请输入第' + (i + 1) + '组的活动信息', 'warning');
                        return false;
                    } else {
                        if (strategy.odCtMutexPromotion !== undefined) {
                            for (let j = 0; j < strategy.odCtMutexPromotion.length; j++) {
                                let promotion = strategy.odCtMutexPromotion[j];
                                if (promotion._status != 'Delete') {
                                    count++;
                                    if (!promotion.iSortNum) {
                                        cb.utils.alert('请输入第' + (i + 1) + '组的第' + count + '行的优先级 ', 'warning');
                                        return false;
                                    } else if (!promotion.iPromotionId) {
                                        cb.utils.alert('请输入第' + (i + 1) + '组的第' + count + '行的活动 ', 'warning');
                                        return false;
                                    }
                                }
                            }
                        }
                        if (count == 0 && viewmodel.get('odCtMutexStrategy').getRows().length != 1) {
                            cb.utils.alert('请输入第' + (i + 1) + '组的活动信息', 'warning');
                            return false;
                        }
                    }
                }
                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_ordermutexstrategy_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_ordermutexstrategy_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_ordermutexstrategy_VM.Extend.js